import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyDigit]',
  standalone: false,
})
export class OnlyDigitDirective {
  private readonly _regex = new RegExp('^[0-9]*$');

  constructor() {}

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    return this._regex.test(event.key);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pasteData = event.clipboardData.getData('text/plain').replace(/\D/g, '');
    document.execCommand('insertHTML', false, pasteData);
  }
}
